class LandingVideoElement extends HTMLElement {
  constructor()  {
    super();

    this.video = this.querySelector('video');
    this.vimeoVideo = this.querySelector('iframe.js-vimeo');
    this.vimeoPlayer = null;
    this.poster = this.querySelector('.landing-video-text__video-poster');
  }

  connectedCallback() {
    const interval = setInterval(() => {
      if (window.Vimeo) {
        clearInterval(interval);
        this.vimeoPlayer = new Vimeo.Player(this.vimeoVideo);
      }
    }, 200);

    setTimeout(() => clearInterval(interval), 5000);

    if (this.video) {
      this.poster.addEventListener('click', this.playVideo.bind(this));
    } else if (this.vimeoVideo) {
      this.poster.addEventListener('click', this.playVimeoVideo.bind(this));
    } else {
      this.poster.addEventListener('click', () => {
        this.poster?.classList.add('landing-video-text__video-poster--hidden');
      })
    }
  }

  playVideo() {
    this.poster?.classList.add('landing-video-text__video-poster--hidden');
    this.video.play();
  }

  playVimeoVideo() {
    if (!this.vimeoPlayer) return;
    this.vimeoPlayer.play();

    this.poster?.classList.add('landing-video-text__video-poster--hidden');
  }
}

if (!customElements.get('landing-video-element')) {
  customElements.define('landing-video-element', LandingVideoElement);
}